<div class="loader" id="loggingInModal">
  <img src="../../../../assets/images/loader2.gif" width="90" height="75" alt="Loading Animation" />
  <p class="card-caption">{{ statusMessage }}</p>
</div>
